"use client";
import { Container, Row, Accordion, Col, Button } from "react-bootstrap";
import Link from "next/link";
import "../../styles/CustomCss/terms.css";
export default function InspectNAUterms() {
  return (
    <>
      <Row className="m-l-0 m-r-0 p-l-0 p-r-0">
        <Container fluid>
          <Row className="text-start">
            <Row
              className=" pt-5 pb-5 text-center"
              style={{
                backgroundImage: "url(/Images/inner-page-banner.png)",
                backgroundRepeat: "no-repeat",
                backgroundSize: " cover",
                backgroundPosition: " 0px center",
                margin: " 0px",
                height: " 290px",
              }}
            >
              <div className="col-md-2 col-12"></div>

              <div className="col-md-8 col-12">
                <h1
                  className="BiEmpowering"
                  style={{
                    color: "rgb(5, 81, 96)",
                    paddingTop: " 70px",
                    textAlign: " center",
                  }}
                >
                  InspectNAU Terms & Conditions
                </h1>
                <h3
                  style={{
                    color: " rgb(5, 81, 96)",
                    paddingTop: " 10px",
                    textAlign: " center",
                  }}
                >
                  <i>Last updated: 01st Jan 2026 | Orion Marine Concepts</i>
                </h3>
              </div>

              <div className="col-md-2 col-12"></div>
            </Row>
          </Row>
        </Container>
        <Container>
          <Row className="text-start">
            <Col xs={12} md={2}></Col>
            <Col xs={12} md={8}>
             
             <section class="terms-page">
    <div class="terms-container">

       
        <div class="terms-intro">
            <p>
                By registering for or using <strong>InspectNAU</strong>, you agree
                to these terms. Please read them before continuing.
            </p>
        </div>

      
        <div class="terms-content">

            <section class="terms-section">
                <h2>1. The Service</h2>
                <p>
                    InspectNAU is a maritime inspection management app supporting
                    SIRE 2.0, RightShip, and your own custom inspection, audit,
                    and condition-based checklists. It works fully offline,
                    and includes a desktop/laptop workflow for exporting and
                    re-importing inspections.
                </p>
            </section>

            <section class="terms-section">
                <h2>2. Your Account</h2>
                <p>
                    You're responsible for keeping your login credentials secure.
                    Each account supports up to <strong>2 registered devices</strong>.
                    You can view and manage your registered devices from within
                    the app.
                </p>
            </section>

            <section class="terms-section">
                <h2>3. Free Trial &amp; Subscription</h2>
                <p>
                    New accounts include a <strong>30-day free trial</strong>
                    with full access, starting from the date of registration.
                    After the trial, continued use requires a paid subscription —
                    currently <strong>USD 9.99/month</strong> or a discounted
                    annual plan <em>[confirm final annual price]</em>, billed
                    through the Apple App Store or Google Play Store depending
                    on your device.
                </p>

                <p>
                    Subscriptions renew automatically unless cancelled at least
                    24 hours before the end of the current period. You can manage
                    or cancel your subscription anytime through your App Store
                    or Play Store account settings. Payment is charged at
                    confirmation of purchase; we don't offer refunds for partial
                    subscription periods.
                </p>
            </section>

            <section class="terms-section">
                <h2>4. Your Content</h2>
                <p>
                    You retain ownership of the inspection data and custom
                    checklists you create or upload. By using InspectNAU,
                    you grant us the license needed to store, sync, and process
                    that content solely to provide the service to you.
                </p>
            </section>

            <section class="terms-section">
                <h2>5. Acceptable Use</h2>
                <p>
                    You agree to use InspectNAU only for lawful, legitimate
                    inspection and audit purposes, and not to attempt to
                    circumvent the device limit, subscription system, or any
                    other part of the app's security.
                </p>
            </section>

            <section class="terms-section">
                <h2>6. Intellectual Property</h2>
                <p>
                    InspectNAU, its default checklists (including SIRE 2.x
                    and RightShip templates), and its underlying software are
                    the property of Orion Marine Concepts. These terms don't
                    transfer any ownership of that property to you.
                </p>
            </section>

            <section class="terms-section">
                <h2>7. Disclaimer</h2>
                <p>
                    InspectNAU is a tool to support inspection and audit
                    workflows. It does not replace professional judgment,
                    and Orion Marine Concepts is not responsible for decisions
                    made solely on the basis of app output. The service is
                    provided <strong>"as is,"</strong> without warranties
                    of any kind.
                </p>
            </section>

            <section class="terms-section">
                <h2>8. Limitation of Liability</h2>
                <p>
                    To the fullest extent permitted by law, Orion Marine
                    Concepts is not liable for indirect, incidental, or
                    consequential damages arising from use of InspectNAU.
                </p>
            </section>

            <section class="terms-section">
                <h2>9. Termination</h2>
                <p>
                    We may suspend or terminate an account that violates these
                    terms. You may stop using the app and cancel your subscription
                    at any time.
                </p>
            </section>

            <section class="terms-section">
                <h2>10. Governing Law</h2>
                <p>
                    These terms are governed by the laws of India.
                </p>
            </section>

            <section class="terms-section">
                <h2>11. Changes to These Terms</h2>
                <p>
                    We may update these terms from time to time. Continued use
                    of InspectNAU after a change means you accept the updated
                    terms.
                </p>
            </section>

            <section class="terms-section terms-contact">
                <h2>12. Contact Us</h2>

                <div class="contact-details">
                    <p>
                        <strong>Orion Marine Concepts</strong>
                    </p>
                    <p>
                        Email:
                        <a href="mailto:helpdesk@orionmarineconcepts.com">
                            helpdesk@orionmarineconcepts.com
                        </a>
                    </p>
                </div>
            </section>

        </div>

    </div>
</section>

            </Col>
            <Col xs={12} md={2}></Col>
          </Row>
        </Container>
        <Container fluid style={{ padding: "0" }} className=" m-t-40 text-left">
          <Row style={{ margin: "0", padding: "0" }}>
            <Row
              className=" pt-5 pb-5 text-center"
              style={{
                backgroundImage: "url(/Images/Nau/CrossPattern.jpg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "0",
                margin: "0",
              }}
            >
              <Col xs={12} md={8}>
                <h1
                  className="BiEmpowering"
                  style={{ color: "#ffffff", paddingTop: "3%" }}
                >
                  Ready to Sail?{" "}
                </h1>
                <h1
                  className="BiEmpoweringBottomText"
                  style={{ color: "#ffffff", paddingTop: "3%" }}
                >
                  Set sail on a journey that redefines efficiency and ushers in
                  a new era in maritime management. Join the NAU 2.1 wave today.{" "}
                </h1>
              </Col>
              <Col xs={12} md={4}>
                <Button
                  variant="light"
                  className="m-t-90 p-l-50 p-r-50 fs-25 p-t-10 p-b-10 btn btn-light"
                >
                  <Link href="/ScheduleDemo" style={{ fontSize: "1.4rem" }}>
                    Embark Now
                  </Link>
                </Button>
              </Col>
            </Row>
          </Row>
        </Container>
      </Row>
    </>
  );
}
